import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Drawer, Popconfirm, Row } from 'antd';
import '../ProspectCustomerDetail/info-card.css';
import { DeleteOutlined, UserOutlined } from '@ant-design/icons';
import { formatDateString, openNotification } from '../../utils';
import EduLearnerService from '../../services/EduLearnerService';
import NoteCreate from './NoteCreate';

const Notes: React.FC<any> = ({ learnerId, setTriggerUpdate }) => {
    const [open, setOpen] = useState(false);
    const authUsername = localStorage.getItem('username');

    const sortNotes = (notesArray: any) => {
        return notesArray.sort((a: any, b: any) => {
            return new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime();
        });
    };

    const [allNotes, setAllNotes] = useState([]);

    const getNotes = () => {
        EduLearnerService.getNotes(learnerId)
            .then((response: any) => {
                setAllNotes(sortNotes(Array.isArray(response.data) ? response.data : []));
            })
            .catch((e: Error) => {
                console.log(e);
            });
    };

    useEffect(() => {
        if (learnerId) {
            getNotes()
        }
    }, [learnerId])

    const handleNoteAdded = () => {
        setTriggerUpdate((prev: number) => prev + 1);
    };

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const confirmDeleteNote = (id: any, createdUser: any) => {
        if (authUsername === createdUser) {
            EduLearnerService.removeNote(id)
                .then(() => {
                    openNotification('success', 'Success', 'Note deleted');
                    handleNoteAdded();
                    getNotes();
                }).catch(() => {
                    openNotification('error', 'Error', 'Failed to delete note');
                });
        } else {
            openNotification('error', 'Error', 'You cannot delete notes that you did not create');
        }
    }

    useEffect(() => {
        if (Array.isArray(allNotes)) {
            setAllNotes(sortNotes(allNotes));
        }
    }, [allNotes]);

    return (
        <>
            <Drawer width={450} placement="right" closable={true} onClose={onClose} open={open}>
                <NoteCreate getNotes={getNotes} learnerId={learnerId} onNoteAdded={handleNoteAdded} onClose={onClose} />
            </Drawer>
            <Card bordered={false} className={'card'}>
                <Row justify={'space-between'}>
                    <p className='title'>Notes</p>
                    <Button type='primary' onClick={showDrawer}>Add Note</Button>
                </Row>
                <p className='description'>{allNotes?.length} Notes</p>
                <div className="notes-container">
                    <Row justify="space-between" align="middle" className="note-row-title">
                        <Col span={2} className='note-table-title'>USER</Col>
                        <Col span={14} className='note-table-title'>NOTE</Col>
                        <Col span={5} className='note-table-title'>DATE</Col>
                        <Col span={3} className='note-table-title'></Col>
                    </Row>
                    {allNotes?.map((item: any) => (
                        <Row key={item.id} justify="space-between" align="middle" className="note-row">
                            <Col span={2} className='note-text'>
                                <UserOutlined style={{ fontSize: 18, color: '#1890ff' }} />
                            </Col>
                            <Col span={14} className='note-text' style={{ paddingRight: 25, whiteSpace: 'pre-wrap' }}>
                                <div style={{ marginBottom: 4 }}>
                                    <strong>{item.createdUser}</strong>
                                </div>
                                <div>{item.note}</div>
                            </Col>
                            <Col span={5} className='note-text'>{formatDateString(item.createdAt)}</Col>
                            <Col span={3} className='note-icon-container'>
                                <Popconfirm
                                    title="Delete the note"
                                    description="Are you sure to delete this note?"
                                    onConfirm={() => confirmDeleteNote(item.id, item.createdUser)}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <div className='icon-wrapper'>
                                        <DeleteOutlined />
                                    </div>
                                </Popconfirm>
                            </Col>
                        </Row>
                    ))}
                </div>
            </Card>
        </>
    );
};

export default Notes;
